import React, { useEffect, useState } from "react";
import ClientSettingsList from "./ClientSettingsList";
import ClientListDropdown from "./ClientListDropdown";
import ClientConfiguration from "./ClientConfiguration";
const ClientSettingEditor = ({ api }) => {
    const [clientID, setClientID] = useState(0);
    const [error, setError] = useState("");
    const [enableClinics, setEnableClinics] = useState(false);
    const [reportRandomization, setreportRandomization] = useState(false);
    const [settings, setSettings] = useState([]);

    useEffect(() => {
        setError("");
        const params = { IncludeDetail: true, ClientID: clientID };
        api.transact("GetBrandingInfo", params)
            .then(r => r.apiResult)
            .then(settingResult => setSettings(settingResult))
            .catch(e => {
                if (e.apiStatus === "ERROR") {
                    setError(e.message);
                }
            });
    }, [api, clientID, setError]);

    const [saveRequestError, setSaveRequestError] = useState("");

    return (
        <div>
            <h1>Client Settings Editor</h1>
            <div className="ClientSettingEditorDiv">
                <ClientListDropdown
                    api={api}
                    clientID={clientID}
                    setClientID={setClientID}
                />
                {error !== "" ? <p>{error}</p> : <></>}
            </div>
            <hr />
           
            <div className="saveRequestErrorClientSettingsListDiv">
                {saveRequestError}
            </div>
            {settings?.length !== 0 ? (
                <ClientSettingsList
                    api={api}
                    settings={settings}
                    setSettings={setSettings}
                    clientID={clientID}
                />
            ) : (
                <></>
            )}
            <hr/>
              <ClientConfiguration
                api={api}
                clientID={clientID}
                enableClinics={enableClinics}
                setEnableClinics={setEnableClinics}
                reportRandomization={reportRandomization}
                setreportRandomization={setreportRandomization}
            />

            <hr />
        </div>
    );
};

export default ClientSettingEditor;
